<!-- 
<nav class="navbar navbar-expand-lg navbar-light bg-light d-flex justify-content-between p-3 px-4">
    <div class="">

      <a class="navbar-brand header-color d-none d-lg-block" href="#">SIEMENS</a>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarTogglerDemo02" aria-controls="navbarTogglerDemo02" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
    </div>
    <div>
      <div class=" d-flex align-item-center ">
        <button class="btn btn-light px-0 mx-3  "><a class="nav-item nav-link mx-3 help-header  p-0" href="#"><img src="assets/images/helpicon.png" width="30" />Help </a>   
        </button>
        <a href="/logout"><i class="fa-solid fa-arrow-right-from-bracket logout-icon  "></i></a>
        
      </div>
    </div>
</nav>
 -->

<header class="header">
  <nav class="navbar">
    <div class="container-fluid m-0 p-0">
      <div class="navbar-holder d-flex align-items-center justify-content-between">
        <div class="navbar-header d-flex">

          <a id="toggle-btn" (click)="toggleSidebar()" class="menu-btn mx-2"><i class="fa fa-bars" aria-hidden="true"></i> </a>
          <a (click)="toggleSidebar()" class="navbar-brand">
            <div class="brand-text d-md-inline-block"><strong class="text-primary"><img height="40"
                  src="assets/images/SE_Logo_Color_RGB.png" class="ps-3"></strong></div>
          </a>
        </div>
        <ul class="nav-menu">
          <!-- Notifications dropdown-->
          <!-- <img src="assets/images/Logout.png"> -->
          <!-- <a href="/admin/helpcenter" class="help"><img src="assets/images/helpicon.png" width="30" />Help</a> -->
          <a *ngIf="profile.role === 1"  class="help" (click)="navigateToHelpDesk()"><img src="assets/images/helpicon.png" width="30" />Help</a>
          <a *ngIf="profile.role !== 1"  class="help" (click)="navigateToHelpDesk()"><img src="assets/images/helpicon.png" width="30" />Help</a>
          <a (click)="logout()"><i class="fa-solid logout-icon cursorHand"></i></a>
        </ul>

      </div>
    </div>
  </nav>
</header>
